export default __webpack_public_path__ + "static/media/header_image.0b512128.png";